define([], function () {

    // noinspection UnnecessaryLocalVariableJS
    /**
     *
     * @param {number} num
     * @param {number} precision
     * @returns {number|string|*}
     * @constructor
     */
    var NumberFormat = function (num, precision) {
        this.num = num;
        this.precision = typeof precision !== 'undefined' ? precision : 2;

        /**
         * #10 규칙에 따라 버림 처리
         *
         * - 0.1 미만: 소수점 앞자리 0을 모두 보존하고 그 뒤 숫자 2개를 표시
         * - 0.1 이상: 소수점 2자리로 자름(버림)
         *
         * @param {Number} number
         * @param {Boolean} is_fixed 소수점 자리수 고정 여부
         * @param {Number} fraction_digits 소수점 자리수
         * @returns {string}
         */
        function numFormat(number, is_fixed, fraction_digits) {
            if (number === 0 || number === "0")
            {
                return "0";
            }
            if (!number)
            {
                return '';
            }

            var str;
            if (is_fixed)
            {
                str = floor(number, fraction_digits);
            }
            else
            {
                str = number + '';
            }

            // 1000 단위 콤마 삽입
            var reg = /(^[+-]?\d+)(\d{3})/;
            while (reg.test(str)) str = str.replace(reg, '$1' + ',' + '$2');

            return str;
        }

        function floor(n, fraction_digits) {
            return (n >= 0.1) ? floorDrop(n, fraction_digits) : floorToVisibleDecimals(n, fraction_digits);
        }

        /**
         * 소수점 x 자리만 살림
         * @param {Number} num
         * @param {Number} fraction_digits
         * @returns {String}
         */
        function floorDrop(num, fraction_digits) {
            var digits = Math.pow(10, fraction_digits);
            num = Math.floor(num * digits) / digits;
            return num.toFixed(fraction_digits);
        }

        /**
         * 0.1 미만밀 경우 0.0 이하 0을 모두 보존하고 마지막 숫자 2개를 붙인 값 반환
         *
         * eg) 0.001234 => 0.0012
         *     0.0000001234 => 0.00000012
         *
         * @param {Number} num
         * @param {Number} fraction_digits
         * @returns {String}
         */
        function floorToVisibleDecimals(num, fraction_digits) {
            var num_str = num.toString();
            var regexp = new RegExp("/^(0\\.)(0+)(\\d{" + fraction_digits + "})(\\d*)/");
            // #10 규칙에 맞게 표시
            return num_str.replace(regexp, "$1$2$3");
        }

        function decimalSpan(str) {
            if (str == 0) return str;

            if (str.indexOf(".") < 0) return str;
            return str.replace(/^(.+\.)(.*)$/, "$1<span class=\"decimal-value\">$2</span>");
        }

        this.amount = function () {
            return numFormat(this.num, true, this.precision);
        };

        this.amountNoFixed = function () {
            return numFormat(this.num, false, this.precision);
        };

        this.amountHtml = function () {
            return decimalSpan(this.amount());
        };

        this.krw = function () {
            return numFormat(Math.floor(this.num * 100), false, this.precision) + "원";
        };

        this.krwHtml = function () {
            return decimalSpan(this.krw());
        };

        this.usdFlower = function () {
            return "$" + numFormat(this.num * 0.1, true, this.precision);
        };

        this.usdFlowerHtml = function () {
            return decimalSpan(this.usdFlower());
        };

        this.amountFloor = function () {
            return floor(this.num, this.precision);
        };
    };

    return NumberFormat;
});